import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "@a7y/tailwind-catalyst";

interface ActivateTopicConfirmDialogProps {
  open: boolean;
  /** Topic title shown in the confirmation; omitted for a topic not yet saved. */
  topicTitle?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Asks before a learning topic is switched on. The consequence stated here is
 * the audience and schedule of the educational email scheduler:
 * a7y-functions/src/backend-services/email-sequence-engine/educational_email_scheduler.ts
 * runs daily at 08:00 UTC (`schedule: "0 8 * * *"`) over every organization
 * whose ledger status is in ELIGIBLE_LEDGER_STATUSES (`active`, `trialing`).
 */
export function ActivateTopicConfirmDialog({
  open,
  topicTitle,
  onCancel,
  onConfirm,
}: ActivateTopicConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} size="sm">
      <DialogTitle>Switch this topic on?</DialogTitle>
      <DialogBody>
        <div className="space-y-4">
          <div className="rounded-lg bg-amber-50 p-4 text-sm text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">
            Once active, this topic is emailed at the next 08:00 UTC run to
            every active and trialing organization that matches its target
            stages and has not used the feature.
          </div>
          {topicTitle && (
            <dl className="space-y-3 text-sm">
              <div className="flex justify-between">
                <dt className="text-zinc-500 dark:text-zinc-400">Topic</dt>
                <dd className="font-medium text-zinc-900 dark:text-white">
                  {topicTitle}
                </dd>
              </div>
            </dl>
          )}
        </div>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onCancel}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm}>
          Switch on
        </Button>
      </DialogActions>
    </Dialog>
  );
}
